import React from "react";
import Tab, { TabGroup } from "@amzn/meridian/tab";
import { BUSINESS_TYPES } from "../settings/settingsv2/ssd/SsdSettingsConstant";

const BusinessFilter = ({
  selectedBusiness,
  onBusinessChange,
  groceryEnabled = false,
}) => {
  const handleBusinessChange = (newBusiness) => {
    onBusinessChange(newBusiness);
  };
  const getAvailableBusinessTabs = () => {
    const tabs = [{ key: BUSINESS_TYPES.CORE, label: "SSD" }];
    if (groceryEnabled) {
      tabs.push({ key: BUSINESS_TYPES.GROCERY, label: "Grocery" });
    }
    return tabs;
  };

  return (
    <TabGroup value={selectedBusiness} onChange={handleBusinessChange}>
      {getAvailableBusinessTabs().map(({ key, label }) => (
        <Tab key={key} value={key}>
          {label}
        </Tab>
      ))}
    </TabGroup>
  );
};

export default BusinessFilter;



// WEBPACK FOOTER //
// ./src/components/common/BusinessFilter.js